import { CountrySchema } from '@/constructs/CountrySchema';
import { ZodType, z } from 'zod';
import { Brand } from '@/constructs/Brand';
import { MoneySchema } from '../Money/schemas';
import IShippingMethod from './IShippingMethod';

export const ShippingMethodSchema = z.object({
  id: z.string(),
  uid: z.string(),
  country: CountrySchema,
  brand: z.nativeEnum(Brand),
  name: z.string(),
  description: z.string(),
  shippingCost: MoneySchema,
  tax: MoneySchema,
  taxRate: z.number(),
  latestDeliveryDays: z.number().nullable(),
  earliestDeliveryDays: z.number().nullable(),
  earliestDeliveryDateOverride: z.string().nullable(),
  latestDeliveryDateOverride: z.string().nullable(),
  formattedDeliveryEstimate: z.string().nullable(),
  deliveryMessageHTML: z.string().nullable(),
  additionalMessage: z.string().nullable(),
  cutoffTime: z.string(),
  cutoffDisplay: z.number()
}) as ZodType<IShippingMethod>;
